<app-loader *ngIf="loading | async" [mensajes]="['Estamos validando tus datos...', 'Últimos pasos...', 'A punto de terminar...']"></app-loader>

